/**
 * Create Item Schema for DataLayer
 * @see     https://github.com/EmmazingEm/Mothers-GA4-DL-Specs/blob/main/schemas/items.md
 * @author  Greg Slonina
 */

function dataLayerItem(itemSchema, itemOutOfStock, productCollections) {
    
    let item = itemSchema

    if (itemOutOfStock === null) {
        itemOutOfStock = false
    }

    if (productCollections === null) {
        productCollections = []
    }

    if (itemOutOfStock) {
        item['item_out_of_stock'] = true
    }

    if (productCollections.length > 0) {
        productCollections = productCollections.slice(0,5)
        let keyItemCategory = 'item_category'
        productCollections.forEach((element, index) => {
        if (index > 0) {
            keyItemCategoryIndex = index + 1
            keyItemCategory = `item_category${keyItemCategoryIndex}`
        }
        item[keyItemCategory] = productCollections[index]
        })
    }
    
    return item
}